export const LS_BANNER_REFUSED_TS = 'autoSendBannerRefusedTs';
